// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AcquisitionCosts__Heading {
  font-size: 1.2rem;
  display: inline-block;
  flex-basis: 100%;
}
.AcquisitionCosts__Form {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-start;
  align-items: center;
  margin-top: 0.5rem;
}

::ng-deep ion-item.subtotal {
  --color: black;
  font-size: 1rem;
  max-width: 20rem !important;
}
::ng-deep ion-item.subtotal label {
  font-weight: bold;
  font-style: italic;
}
::ng-deep ion-item.Input {
  max-width: 10rem;
}

.flex-break {
  flex-basis: 100%; /* Forces the element to take full width */
  height: 0; /* Makes it visually invisible */
  margin: 0; /* Removes any default margins */
  padding: 0; /* Removes any default padding */
}`, "",{"version":3,"sources":["webpack://./apps/app/src/app/views/property-details/components/acquisition-costs/acquisition-costs.component.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;EACA,qBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;AADJ;;AAME;EACE,cAAA;EACA,eAAA;EACA,2BAAA;AAHJ;AAKI;EACE,iBAAA;EACA,kBAAA;AAHN;AAOE;EACE,gBAAA;AALJ;;AASA;EACE,gBAAA,EAAA,0CAAA;EACA,SAAA,EAAA,gCAAA;EACA,SAAA,EAAA,gCAAA;EACA,UAAA,EAAA,gCAAA;AANF","sourcesContent":[".AcquisitionCosts {\n  &__Heading {\n    font-size: 1.2rem;\n    display: inline-block;\n    flex-basis: 100%;\n  }\n\n  &__Form {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n    justify-content: flex-start;\n    align-items: center;\n    margin-top: 0.5rem;\n  }\n}\n\n::ng-deep {\n  ion-item.subtotal {\n    --color: black;\n    font-size: 1rem;\n    max-width: 20rem !important;\n\n    label {\n      font-weight: bold;\n      font-style: italic;\n    }\n  }\n\n  ion-item.Input {\n    max-width: 10rem;\n  }\n}\n\n.flex-break {\n  flex-basis: 100%; /* Forces the element to take full width */\n  height: 0; /* Makes it visually invisible */\n  margin: 0; /* Removes any default margins */\n  padding: 0; /* Removes any default padding */\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
